import validator from 'validator';
import { DEFAULT_COUNTRY_CODE, getE164PhoneNumber } from '@/utils/phone-number';
import {
  InviteEmployeeFormState,
  UseInviteEmployeeFormResult,
} from '@sales-portal/domain/accounts/screens/employee-list/containers/employee-invite-drawer/types';
import { useState } from 'react';

const INITIAL_FORM_STATE: InviteEmployeeFormState = {
  communicationEmail: '',
  countryCode: DEFAULT_COUNTRY_CODE,
  isAdmin: false,
  loginEmail: '',
  name: '',
  phoneNumber: '',
};

export const useInviteEmployeeForm = (): UseInviteEmployeeFormResult => {
  const [form, setForm] = useState<InviteEmployeeFormState>(INITIAL_FORM_STATE);

  const setFormField = <K extends keyof InviteEmployeeFormState>(
    key: K,
    value: InviteEmployeeFormState[K],
  ) => {
    setForm((prev) => ({ ...prev, [key]: value }));
  };

  const fullName = form.name.trim();
  const phoneNumber = form.phoneNumber.trim();
  const loginEmail = form.loginEmail.trim();
  const communicationEmail = form.communicationEmail.trim();

  const isPhoneValid =
    !phoneNumber || getE164PhoneNumber(phoneNumber, form.countryCode) !== null;
  const isLoginEmailValid = !loginEmail || validator.isEmail(loginEmail);
  const isCommunicationEmailValid =
    !communicationEmail || validator.isEmail(communicationEmail);
  const hasLoginMethod = !!(phoneNumber || loginEmail);

  const canSubmit =
    !!fullName &&
    hasLoginMethod &&
    isPhoneValid &&
    isLoginEmailValid &&
    isCommunicationEmailValid;

  return {
    canSubmit,
    form,
    setFormField,
  };
};
